import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ImageIcon } from "lucide-react";
import { api, assetUrl } from "../lib/api";
import { formatMoney } from "../lib/pricing";

export default function Yachts() {
  const [yachts, setYachts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/yachts")
      .then((r) => setYachts(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="yachts-page">
      <section className="hbe-container pt-16 md:pt-24 pb-8">
        <div className="max-w-2xl">
          <div className="hbe-eyebrow">The Fleet</div>
          <h1 className="mt-3 font-serif text-4xl md:text-5xl">Yachts</h1>
          <p className="mt-4 text-hbe-ink/70">
            Private charters in Miami. Each yacht is available on a fully
            private basis with a four-hour minimum.
          </p>
        </div>
      </section>

      <section className="hbe-container pb-24">
        {loading ? (
          <div className="text-hbe-ink/55" data-testid="yachts-loading">
            Loading yachts…
          </div>
        ) : yachts.length === 0 ? (
          <div className="text-hbe-ink/55" data-testid="yachts-empty">
            No yachts available at the moment.
          </div>
        ) : (
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
            {yachts.map((y) => (
              <Link
                to={`/yachts/${y.slug}`}
                key={y.id}
                className="group"
                data-testid={`yacht-card-${y.slug}`}
              >
                <div className="aspect-[4/3] rounded-xl overflow-hidden bg-hbe-soft">
                  {y.thumbnail_url || y.images?.[0] ? (
                    <img
                      src={assetUrl(y.thumbnail_url || y.images[0])}
                      alt={`${y.name} — feature photograph`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                      loading="lazy"
                    />
                  ) : (
                    <div
                      className="w-full h-full flex flex-col items-center justify-center gap-2 text-hbe-accent"
                      data-testid="empty-photos-tile"
                    >
                      <ImageIcon size={28} strokeWidth={1.4} />
                      <div className="text-sm">Photos coming soon</div>
                    </div>
                  )}
                </div>
                <div className="mt-5">
                  <h2 className="font-serif text-2xl">{y.name}</h2>
                  <div className="text-sm text-hbe-ink/70 mt-1">
                    Up to {y.capacity} guests · from{" "}
                    <span className="text-hbe-primary font-medium">
                      {formatMoney(y.base_price)} / {y.minimum_duration_hours} hours
                    </span>
                  </div>
                  {y.description && (
                    <p className="mt-3 text-sm text-hbe-ink/70 line-clamp-3">
                      {y.description}
                    </p>
                  )}
                  <div className="mt-4 inline-flex items-center text-sm text-hbe-primary group-hover:underline">
                    View yacht →
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
